import { FetchListFilterOptions, FetchListOptions } from '~/api/_types';
import { AppTablePagination } from '~/components/base/tables/_types';
import { fetchDemands } from '~/services/demands';

export const useDemands = (
    initialPagination?: AppTablePagination | null,
    implicitFilter?: FetchListFilterOptions[] | null
) => {
    const { data, pagination, userFilter, isLoading, request } = useApiCollectionData(
        async (opt?: FetchListOptions) => await fetchDemands(opt),
        initialPagination,
        implicitFilter
    );

    return {
        data,
        pagination,
        userFilter,
        isLoading,
        request,
    };
};
